<template>
    <div class="about-page" style="background-color: #f5f5f5;">
        <nav class="nav-container">
            <headers></headers>
            <div class="nav-tabs">
                <div class="Logo-container">
                    <div class="Logo">
                        <div>
                            <img style="width: 40px;" :src="navItems[0].link" alt="">
                        </div>
                        <div>
                            {{ navItems[0].name }}
                        </div>
                    </div>
                </div>
                <div class="nav-items-group">
                    <div @mouseover="dropDownChange(item)" v-for="item in navItems" :key="item.name"
                        v-show="item.name !== '遵农共享'">
                        <div @click="Active(item)" class="nav-item" :class="{ 'active': activeNav === item.name }"
                            v-if="item.name === 'sustainableDevelopment' || item.name === 'home'">
                            {{ $t(`navItems.${item.name}`) }}
                        </div>
                        <el-dropdown @command="handleCommand" v-else trigger="hover" class="nav-item"
                            :class="{ 'active': activeNav === item.name }">
                            <div>
                                {{ $t(`navItems.${item.name}`) }}
                            </div>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :command="subItem" class="dropdown-item" v-for="subItem in downList"
                                    :key="subItem.label">{{ $t(`downlist.${subItem.label}`)
                                    }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
        </nav>
        <div style="background-color: #fff;" v-show="overview">
            <section style="min-width: 100%;position: relative;">
                <div class="about-content">
                    {{ $t(`aboutUs.title`) }}
                </div>
                <div
                    style="width: 1500px;margin: 0 auto;position: absolute;top: 10em;display: flex;flex-direction: column;left: 50%;transform: translateX(-50%);">
                    <div style="text-indent: 2em;">
                        {{ $t(`aboutUs.content1`) }}
                    </div>
                    <div style="text-indent: 2em;">
                        {{ $t(`aboutUs.content2`) }}
                    </div>
                    <div style="text-indent: 2em;">
                        {{ $t(`aboutUs.content3`) }}
                    </div>
                </div>

                <img style="width: 100%;height: 65em;" src="../images/24821412_213826942123_2.jpg" alt="">

            </section>
            <section style="width: 100%;margin-top: 10em;">
                <div class="about-content">
                    {{ $t(`aboutUs.title1`) }}
                </div>
                <div style="text-align: center;font-size: 1.8em;">
                    {{ $t(`aboutUs.content4`) }}
                </div>
                <div style="text-align: center;font-size: 1.2em;margin-top: 2em;">
                    {{ $t(`aboutUs.content5`) }}
                </div>
                <div>
                    <img style="width: 100%;height: 65em;" src="../images/VCG211377914193.jpg" alt="">
                </div>
            </section>
        </div>
        <!-- 公司荣誉 -->
        <div v-show="honor" style="width: 1500px;margin: 0 auto;background-color: #fff;">
            <div>
                <div class="about-content">
                    {{ $t(`aboutUs.title2`) }}
                </div>
                <div style="text-align: center;font-size: 1em;margin: 2em;">
                    {{ $t(`aboutUs.content6`) }}
                </div>
            </div>
            <div class="img-container">
                <div style="width: 25em;" v-for="item in rongyu" :key="item.imgUlr">
                    <img style="width: 100%;height: 15em;" :src="item.imgUlr" alt="">
                </div>
            </div>
        </div>
        <!-- 新闻中心 -->
        <div v-show="news" style="width: 1500px;margin: 0 auto;">
            <div style="margin: 2em;">
                <div class="about-content">
                    {{ $t(`aboutUs.title3`) }}
                </div>
            </div>
            <div>
                <div class="news">
                    <div style="display: flex;align-items: center;background-color: #fff;margin: 1.5em 0;box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);"
                        v-for="item in newsList" :key="item.imgUlr">
                        <div style="width: 50%;font-size: 1.5em;padding: 0.5em;">
                            {{ $t(`aboutUs.${item.name}`) }}
                        </div>
                        <div style="width: 50%;">
                            <img style="width: 100%;height: 15em;" :src="item.imgUlr" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import logo from '../images/nyj-logo.jpg';
import headers from '@/components/header/headers';
import rong1 from '../images/rong1.jpg';
import rong2 from '../images/rong2.jpg';
import rong3 from '../images/rong3.jpg';
import rong5 from '../images/rong5.jpg';
import rong6 from '../images/rong6.jpg';
import news1 from '../images/news1.png';
import news2 from '../images/news2.png';
import news3 from '../images/news3.png';
import news4 from '../images/news4.png';
import news5 from '../images/news5.png';
import news6 from '../images/news6.png';
import news7 from '../images/news7.png';
import news8 from '../images/news8.png';
import news9 from '../images/news9.png';
import news10 from '../images/news10.png';

export default {
    name: "About",
    components: { headers },
    data() {
        return {
            newsList: [{
                imgUlr: news1,
                name: 'name1',
            },
            {
                imgUlr: news2,
                name: 'name2',
            },
            {
                imgUlr: news3,
                name: 'name3',
            },
            {
                imgUlr: news4,
                name: 'name4',
            },
            {
                imgUlr: news5,
                name: 'name5',
            },
            {
                imgUlr: news6,
                name: 'name6',
            },
            {
                imgUlr: news7,
                name: 'name7',
            },
            {
                imgUlr: news8,
                name: 'name8',
            },
            {
                imgUlr: news9,
                name: 'name9',
            },
            {
                imgUlr: news10,
                name: 'name10',
            },

            ],
            active: null,
            overview: false,
            honor: false,
            news: false,
            rongyu: [{ imgUlr: rong1 }, { imgUlr: rong2 }, { imgUlr: rong3 }, { imgUlr: rong5 }, { imgUlr: rong6 }, { imgUlr: rong1 }],
            downList: [],
            navItems: [
                { name: "遵农共享", link: logo },
                { name: 'home' },
                { name: "aboutUs" },
                { name: "products" },
                { name: "sustainableDevelopment" },
                { name: "joinUs" }
            ],
            activeNav: 'aboutUs',

        }
    },
    methods: {
        handleCommand(item) {
            console.log(item);
            if (item.label === 'label1' || item.label === 'label2' || item.label === 'label3') {
                if (item.label === 'label1') {
                    this.overview = true;
                    this.honor = false;
                    this.news = false;
                } else if (item.label === 'label2') {
                    this.overview = false;
                    this.honor = true;
                    this.news = false;
                } else if (item.label === 'label3') {
                    this.overview = false;
                    this.honor = false;
                    this.news = true;
                }
            } else if (item.label === 'label4') {
                this.$router.push({ path: 'project', query: { active: 'label4' } });
            }else if (item.label === 'label5') {
                this.$router.push({ path: 'project', query: { active: 'label5' } });
            }else if (item.label === 'label6') {
                this.$router.push({ path: 'project', query: { active: 'label6' } });
            }else if (item.label === 'label7') {
                this.$router.push({ path: 'project', query: { active: 'label7' } });
            }else if (item.label === 'label8') {
                this.$router.push({ path: 'project', query: { active: 'label8' } });
            }else if (item.label === 'label9') {
                this.$router.push({ path: 'project', query: { active: 'label9' } });
            }else if (item.label === 'label10') {
                this.$router.push({ path: 'HomePage', query: { scroll: 'label10' } });
            }else if (item.label === 'label11') {
                this.$router.push({ path: 'HomePage', query: { scroll: 'label11' } });
            }

        },
        // 下拉菜单切换
        dropDownChange(item) {
            this.downList = [];
            if (item.name === 'aboutUs') {
                this.downList = [{ label: 'label1' }, { label: 'label2' }, { label: 'label3' }];
            } else if (item.name === 'products') {
                this.downList = [{ label: 'label4' }, { label: 'label5' }, { label: 'label6' }, { label: 'label7' }, { label: 'label8' }, { label: 'label9' }];
            } else if (item.name === 'joinUs') {
                this.downList = [{ label: 'label10' }, { label: 'label11' }];
            }
        },
        // 导航激活
        Active(item) {
            this.activeNav = item.name;
            console.log(item.name);
            if (item.name === 'home') {
                this.$router.push({ path: 'HomePage' });
            } else if (item.name === 'aboutUs') {
                this.$router.push({ path: 'about' });
            } else if (item.name === 'products') {
                this.$router.push({ path: 'products' });
            } else if (item.name === 'sustainableDevelopment') {
                this.$router.push({ path: 'development' });
            } else if (item.name === 'joinUs') {
                this.$router.push({ path: 'joinUs' });
            }
        }
    },
    created() {
        this.active = this.$route.query.active;
        if (this.active === 'label1') {
            this.overview = true;
            this.honor = false;
            this.news = false;
        } else if (this.active === 'label2') {
            this.overview = false;
            this.honor = true;
            this.news = false;
        } else if (this.active === 'label3') {
            this.overview = false;
            this.honor = false;
            this.news = true;
        }
    }
};
</script>
<style scoped>
.img-container {
    display: grid;
    grid-template-columns: repeat(3, 25em);
    gap: 3em;
    justify-content: center;
}

.about-content {
    text-align: center;
    color: var(--glwColor);
    font-size: 4.2em;
    font-family: 'Courier New', Courier, monospace;
}

.about-container {
    width: 100%;
    max-width: 1500px;
    margin: 0 auto;
}

.dropdown-item:hover {
    color: #46B135;
    background-color: rgba(70, 177, 53, 0.1);
}

.nav-container {
    position: sticky;
    top: 0;
    width: 100%;
    box-shadow: 0 2px 4px rgba(var(--glwColorRgb), 0.1);
    padding: 0 1em;
    background: #fff;
    z-index: 999;
    box-sizing: border-box;
}

.Logo {
    display: flex;
    align-items: center;
    gap: 0.5em;
    font-weight: bold;
}

.nav-tabs {
    margin: 0 auto;
    width: 100%;
    max-width: 1500px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2em;
    cursor: pointer;
}

.nav-items-group {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2em;
    flex: 1;
}

.nav-item {
    text-align: center;
    min-width: 5em;
    font-size: 1em;
    position: relative;
    display: inline-block;
    padding: 0.8em 0;
    line-height: 1.2;
    box-sizing: border-box;
    transition: color 0.3s ease;
}

.nav-item:hover::after,
.nav-item.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--glwColor);
    transition: width 0.3s ease;
}

.nav-item:hover,
.nav-item.active {
    color: var(--glwColor);
}

.about-page {
    --glwColor: #46B135;
    --glwColorRgb: 70, 177, 53;
    font-size: 16px;
}

@media screen and (max-width: 1500px) {
    .about-page {
        font-size: 16px;
    }
}

@media screen and (max-width: 1200px) {
    .about-page {
        font-size: 14px;
    }
}

@media screen and (max-width: 768px) {
    .about-page {
        font-size: 10px;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/about.vue